import React, { useState, useEffect } from "react";
import "../styles/Topbar.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebookF,
  faInstagram,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";

import {
  faUser,
  faHandHoldingHeart,
  faCircleUser,
  faRightFromBracket,
} from "@fortawesome/free-solid-svg-icons";

import { Link, useNavigate, useLocation } from "react-router-dom";

const Topbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isRegistrationPage = location.pathname.includes("homam-registration");
  const [user, setUser] = useState(null);

  // 🔐 Load + sync user
  useEffect(() => {
    const syncUser = () => {
      try {
        const storedUser = localStorage.getItem("user");
        setUser(storedUser ? JSON.parse(storedUser) : null);
      } catch (err) {
        console.error("Invalid user data in localStorage");
        setUser(null);
      }
    };

    syncUser();

    window.addEventListener("storage", syncUser);
    return () => window.removeEventListener("storage", syncUser);
  }, []);

  // 🚪 Logout
  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");

    setUser(null);
    navigate("/account");
  };

  return (
    <div className={`topbar ${isRegistrationPage ? "topbar-compact" : ""}`}>
      <div className={`container topbar-container ${isRegistrationPage ? "topbar-container-compact" : ""}`}>

        {/* LEFT SOCIAL ICONS */}
        <div className="social">

          <a
            href="https://www.facebook.com/share/1HC1MpStwK/"
            target="_blank"
            rel="noopener noreferrer"
            className="icon"
          >
            <FontAwesomeIcon icon={faFacebookF} />
          </a>

          <a
            href="https://www.instagram.com/srignanasaibabamandir"
            target="_blank"
            rel="noopener noreferrer"
            className="icon"
          >
            <FontAwesomeIcon icon={faInstagram} />
          </a>

          <a
            href="https://youtube.com/@srignanasaibabamandir"
            target="_blank"
            rel="noopener noreferrer"
            className="icon"
          >
            <FontAwesomeIcon icon={faYoutube} />
          </a>

        </div>

        {/* RIGHT LINKS */}
        <div className="links">

          <Link to="/about" className="nav-link">
            About Us
          </Link>

          <span className="divider">|</span>

          <Link to="/donate" className="nav-link">
            <FontAwesomeIcon icon={faHandHoldingHeart} /> Donate
          </Link>

          <span className="divider">|</span>

          {/* 👤 PROFILE ONLY AFTER LOGIN */}
          {user && (
            <>
              <Link to="/profile" className="nav-link">
                <FontAwesomeIcon icon={faCircleUser} /> My Profile
              </Link>
              <span className="divider">|</span>
            </>
          )}

          {/* 🔐 AUTH SECTION */}
          {!user ? (
            <Link to="/account" className="nav-link account">
              <FontAwesomeIcon icon={faUser} /> Login
            </Link>
          ) : (
            <div className="nav-link account user-box">

              <span className="username">
                {user.fullName}
              </span>

              <span className="divider">|</span>

              <span onClick={handleLogout} className="nav-link logout-link">
                <FontAwesomeIcon icon={faRightFromBracket} /> Logout
              </span>

            </div>
          )}

        </div>

      </div>
    </div>
  );
};

export default Topbar;